/**
 * Modo da sidebar de navegação do app.
 *
 * - `drawer`: abaixo de lg (1024px) — off-canvas com overlay, como sempre foi.
 * - `expanded`: 256px em fluxo.
 * - `rail`: trilho de 64px só com ícones.
 * - `peek`: trilho no fluxo + painel de 256px por cima (hover/foco).
 *
 * Três camadas decidem: a preferência salva do professor, o override que o
 * editor pede enquanto está montado, e o peek efêmero do hover.
 */
export type SidebarMode = 'drawer' | 'expanded' | 'rail' | 'peek'
export type SidebarOverride = 'collapsed' | 'expanded' | null

export interface SidebarModeInput {
  /** largura da janela ≥ 1024 (useIsMobile().isDesktop) */
  isDesktop: boolean
  /** profiles.configuracoes.ui.sidebarCollapsed */
  collapsedPref: boolean
  /** pedido do editor; null fora dele */
  override: SidebarOverride
  peeking: boolean
}

export const SIDEBAR_EXPANDED_WIDTH = 256
export const SIDEBAR_RAIL_WIDTH = 64
export const SIDEBAR_PEEK_DELAY_MS = 150

export function resolveSidebarMode({ isDesktop, collapsedPref, override, peeking }: SidebarModeInput): SidebarMode {
  if (!isDesktop) return 'drawer'
  const effective = override ?? (collapsedPref ? 'collapsed' : 'expanded')
  if (effective === 'expanded') return 'expanded'
  return peeking ? 'peek' : 'rail'
}
